import {useCallback, useSyncExternalStore} from 'react';

// Lot 8 : bouton « Collecte ». État mémorisé en localStorage (`pilotage.collecte`, '1' | '0') pour survivre à la navigation
// entre les trois écrans ; sur la carte il vit aussi dans le permalien (`collecte=1|0`, cf. permalink.js).
// Défaut : désactivé (les événements `source === 'simulation'` sont alors exclus de l'index, cf. selectors/index.js).

export const CLE_STOCKAGE = 'pilotage.collecte';

const abonnes = new Set();
let memoire = null; // repli si localStorage est indisponible (navigation privée, tests)

/** Lit l'état : '1' -> true ; tout le reste (absent, '0', erreur d'accès) -> false. */
export function lireCollecte(stockage) {
    try {
        const s = stockage === undefined ? (typeof window !== 'undefined' ? window.localStorage : null) : stockage;
        if (s) return s.getItem(CLE_STOCKAGE) === '1';
    } catch (e) {
        // accès refusé : repli mémoire
    }
    return memoire === true;
}

export function ecrireCollecte(valeur, stockage) {
    memoire = !!valeur;
    try {
        const s = stockage === undefined ? (typeof window !== 'undefined' ? window.localStorage : null) : stockage;
        if (s) s.setItem(CLE_STOCKAGE, valeur ? '1' : '0');
    } catch (e) {
        // quota / accès refusé : la valeur reste en mémoire pour la session
    }
    abonnes.forEach((f) => f());
}

function abonner(f) {
    abonnes.add(f);
    return () => abonnes.delete(f);
}

/** [collecte, setCollecte] : état partagé entre les écrans (Coquille, pages). */
export function useCollecte() {
    const valeur = useSyncExternalStore(abonner, () => lireCollecte(), () => false);
    const changer = useCallback((v) => ecrireCollecte(v), []);
    return [valeur, changer];
}
